import { render, staticRenderFns } from "./CompanyEditHistory.vue?vue&type=template&id=68996b84&"
import script from "./CompanyEditHistory.vue?vue&type=script&lang=js&"
export * from "./CompanyEditHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports